import {
  EmailTemplatePreview,
  type EmailTemplateFormData,
} from '@/features/campaigns/components/CreateCampaign_v2/steps/Email/TemplatePreview/EmailTemplatePreview';
import { BaseModal } from '@/lib/Modals/BaseModal/BaseModal';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type EmailTemplatePreviewModalProps = {
  formData: EmailTemplateFormData;
  onClose: () => void;
};

export const EmailTemplatePreviewModal: FC<EmailTemplatePreviewModalProps> = ({ formData, onClose }) => {
  const { t } = useTranslation('campaign');

  return (
    <BaseModal
      onClose={onClose}
      classNames={{
        dialog: 'max-w-[720px] w-full',
        content: 'min-w-0 max-w-none p-4',
      }}
    >
      <h3 className='pr-8 text-lg font-semibold text-gray-900'>{t('emailWorkspace.templates.emailPreview')}</h3>
      <EmailTemplatePreview formData={formData} />
    </BaseModal>
  );
};
